function doesItHaveValue(data, label) {
  return data ? data[label] : null;
}

export { doesItHaveValue };
